import { getIndianTime } from "@/utils/general/date"
import { useEffect, useState } from "react"

/**
 * Custom hook to determine if the current time falls within a specified time range.
 * @param {string} fromTime - The start time of the range in ISO 8601 format (e.g., '2024-03-12T18:10:00').
 * @param {string} toTime - The end time of the range in ISO 8601 format (e.g., '2024-03-12T19:10:00').
 * @param {number} [interval=60000] - The interval time in milliseconds to check the time range (default: 60000 milliseconds).
 * @returns {boolean} - True if the current time falls within the specified range; otherwise, false.
 */
const useVisibilityWithinTimeRange = (fromTime, toTime, interval = 60000) => {
  const [isWithinRange, setIsWithinRange] = useState(false)
  useEffect(() => {
      const startTime = new Date(fromTime)
      const endTime = new Date(toTime)
      // Check if the current time falls within the specified range
      const checkTimeRange = () => {
          const currentTime = getIndianTime()
          console.log(currentTime, 'currentTime')
          setIsWithinRange(currentTime >= startTime && currentTime <= endTime)
      }
      checkTimeRange() // Check immediately
      // Set interval to periodically check time range
      const intervalId = setInterval(checkTimeRange, interval)
      // Cleanup interval on component unmount
      return () => clearInterval(intervalId)
  }, [fromTime, toTime, interval])
  return isWithinRange
}
export default useVisibilityWithinTimeRange